var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51.5789,
    height: 51.5789,
    rx: 17.193,
    fill: "#316FF6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2917_2051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5237 27.5773L28.3411 30.7706C27.0505 32.0657 24.7797 32.0936 23.4613 30.7706L20.2785 27.5773L8.84766 39.0453C9.27315 39.242 9.74229 39.3594 10.241 39.3594H41.5613C42.0601 39.3594 42.5291 39.2422 42.9544 39.0453L31.5237 27.5773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5612 12.6406H10.2409C9.74214 12.6406 9.273 12.758 8.84766 12.9548L21.0624 25.21C21.0632 25.2108 21.0641 25.211 21.065 25.2118C21.0658 25.2126 21.0659 25.2137 21.0659 25.2137L25.0376 29.1985C25.4594 29.6204 26.3428 29.6204 26.7647 29.1985L30.7355 25.2144C30.7355 25.2144 30.7365 25.2126 30.7373 25.2118C30.7373 25.2118 30.7391 25.2108 30.7399 25.21L42.9543 12.9547C42.5289 12.7579 42.06 12.6406 41.5612 12.6406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2556 14.5118C7.03547 14.957 6.90039 15.4512 6.90039 15.9805V36.0195C6.90039 36.5489 7.03532 37.043 7.25553 37.4882L18.7062 26.0004L7.2556 14.5118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5443 14.5117L33.0938 26.0004L44.5443 37.4884C44.7644 37.0432 44.8995 36.549 44.8995 36.0196V15.9805C44.8995 15.451 44.7644 14.9569 44.5443 14.5117Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2917_2051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(6.90039 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogo);
export default __webpack_public_path__ + "static/media/mail_logo.5e0b114b7b123ed4457d3ef2993fcd28.svg";
export { ForwardRef as ReactComponent };